<template>
  <div class="d-flex flex-column vh-100">
    <b-navbar toggleable="lg" type="light">
      <b-navbar-brand :to="{ name: 'PaymentsList' }">
        <img :alt="$constants.APP_NAME" :src="require('../assets/img/logo_admin.svg')"
             class="d-none d-lg-block"/>
        <img :alt="$constants.APP_NAME" :src="require('../assets/img/logo_admin_min.svg')" class="d-lg-none"/>
      </b-navbar-brand>

      <b-navbar-nav class="ml-lg-3">
        <b-nav-text class="title">{{ title }}</b-nav-text>
      </b-navbar-nav>

      <b-navbar-toggle target="nav-text-collapse"/>
      <b-collapse id="nav-text-collapse" is-nav>
        <admin-menu :show-footer="false" class="d-lg-none" in-navbar/>
        <b-nav class="d-lg-none">
          <b-nav-item @click="doLogout" link-classes="logout-link">
            <b-avatar :src="require('../assets/img/user-image-man.png')"/>
            Cerrar Sesión
          </b-nav-item>
        </b-nav>
      </b-collapse>

      <b-navbar-nav class="d-none d-lg-flex align-items-center ml-auto">
        <b-nav-item class="mr-4">
          <navbar-notifications :notifications="4"/>
        </b-nav-item>
        <b-nav-item @click="doLogout" link-classes="logout-link">
          <b-avatar :src="require('../assets/img/user-image-man.png')" class="mr-3"/>
          Cerrar Sesión
        </b-nav-item>
      </b-navbar-nav>

    </b-navbar>
    <main class="d-flex flex-row flex-grow-1">
      <div class="d-none d-lg-block" id="sidebar">
        <admin-menu/>
      </div>
      <div class="flex-grow-1 p-0 py-3 p-lg-5" id="main">
        <div class="service-layout__spinner-container" v-if="show_spinner">
            <b-spinner class="service-layout__spinner" variant="primary"></b-spinner>
        </div>
        <router-view/>
      </div>
      <message-box/>
    </main>
  </div>
</template>

<script>
  import MessageBox from './MessageBox';
  import { mapState, mapActions } from 'vuex';
  import AdminMenu from './AdminMenu';
  import NavbarNotifications from "./NavbarNotifications";

  export default {
    name: "AdminLayout",
    components: { NavbarNotifications, AdminMenu, MessageBox },
    computed: {
      ...mapState('ui', ['title', 'show_spinner']),
    },
    methods: {
      ...mapActions('auth', ['logout']),
      doLogout() {
        this.logout().then(() => {
          this.$router.push({ name: 'Login' })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  #sidebar {
    width: 256px;
    padding-top: 50px;
    padding-bottom: 20px;
  }

  .navbar {
    border-bottom: 1px solid $bg_layout;

    .navbar-brand {
    }

    a.nav-link.logout-link {
      color: $darkgray2;
    }
  }

  #main {
    background-color: $lightergray;
    padding: 3rem;
    box-shadow: inset rgba(0, 0, 0, .1) 2px 2px 4px;
  }

  .title {
    font-size: 1.75rem;
    text-transform: uppercase;
    font-weight: bold;
    color: $textgray;
  }
</style>
